import axios from "axios";

import { getToken } from "../features/auth/authHelpers";

const api = axios.create({
  baseURL: "https://rizee-c3crm-backend-755214126997.us-south1.run.app/",
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token && !config.url.includes("/auth/login")) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;